import { withI18n } from 'react-i18next';
import InvoicesMobile from './InvoicesMobile';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';

import {
  authorizedSel,
  trackingNumberSel,
  errorMessageSel,
  isPendingSel,
  showStatusModalSel,
  errorSel,
  paySimpleActions as paySimplePaymentActions
} from 'src/store/modules/paysimplepayment';
import { invoicesActions, successSel } from 'src/store/modules/invoices';
import { creditCardSuccessSel } from 'src/store/modules/creditcard';

const mapStateToProps = (state: IInitialState) => ({
  authorized: authorizedSel(state),
  trackingNumber: trackingNumberSel(state),
  errorMessage: errorMessageSel(state),
  isPendingPayment: isPendingSel(state),
  showStatusModal: showStatusModalSel(state),
  errorPayment: errorSel(state),
  creditCardSuccess: creditCardSuccessSel(state),
  successPayment: successSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  closeStatusModal: () => {
    dispatch(paySimplePaymentActions.closeStatusModal());
  },
  clearAlert: () => {
    dispatch(invoicesActions.setError(''));
    dispatch(invoicesActions.setSuccess());
  }
});

export const pureComponent = InvoicesMobile;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(InvoicesMobile));
